
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/addressess",
      function () {
        return require("private-next-pages/my-account/addressess.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/addressess"])
      });
    }
  